const ITEMS = [
  "RÉPARATION",
  "ENTRETIEN",
  "DIAGNOSTIC",
  "FREINAGE",
  "PNEUMATIQUES",
  "VIDANGE",
  "PARE-BRISE",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="services-marquee" className="relative border-y border-white/10 bg-[#0A0D16] py-5 overflow-hidden">
      <div className="marquee-track items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span
                  className={`font-display font-bold uppercase tracking-tight text-xl md:text-2xl whitespace-nowrap ${
                    item === "PARE-BRISE" ? "text-[#F59E0B]" : "text-slate-500"
                  }`}
                >
                  {item === "PARE-BRISE" ? "PARE-BRISE : 200€ OFFERTS" : item}
                </span>
                <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${item === "PARE-BRISE" ? "bg-[#F59E0B]" : "bg-[#0066FF]"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
